import React, { useState } from "react";

const SiteMap = ({ setActiveTab }) => {
  const [query, setQuery] = useState("");

  const pages = [
    { name: "ग्राम पं. (About)", tab: "about" },
    { name: "एक खिडकी (Window)", tab: "window" },
    { name: "गांवाचा अभिमान (Abhiman)", tab: "abhiman" },
    { name: "समारंभ (Events)", tab: "events" },
    { name: "शासकीय उपक्रम (Programs)", tab: "programs" },
    { name: "नाविन्यपूर्ण उपक्रम (New Programs)", tab: "newprograms" },
    { name: "योजना (Schemes)", tab: "schemes" },
    { name: "शिक्षण रोजगार (Jobs)", tab: "jobs" },
    { name: "गांव मंच (VillageMunch)", tab: "VillageMunch" },
  ];

  const filtered = pages.filter((p) =>
    p.name.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h2>🗺️ साइट मॅप</h2>
      <input
        type="text"
        placeholder="शोधा..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        style={{
          padding: "10px",
          width: "60%",
          maxWidth: "400px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          marginBottom: "20px",
        }}
      />

      <ul style={{ listStyle: "none", padding: 0 }}>
        {filtered.length > 0 ? (
          filtered.map((page) => (
            <li key={page.tab} style={{ margin: "10px 0" }}>
              <button
                onClick={() => setActiveTab(page.tab)} // ✅ uses prop instead of window
                style={{
                  background: "none",
                  border: "none",
                  color: "#007bff",
                  cursor: "pointer",
                  fontSize: "1.1rem",
                }}
              >
                {page.name}
              </button>
            </li>
          ))
        ) : (
          <p>काहीही सापडले नाही.</p>
        )}
      </ul>
    </div>
  );
};

export default SiteMap;
